// eslint-disable-next-line import/no-extraneous-dependencies
import { createBrowserHistory } from 'history';

// eslint-disable-next-line import/prefer-default-export
export const history = createBrowserHistory();
